export default String.raw`
.formal-content {
    margin: 0 32px;
}
`